import { useTranslation } from "react-i18next";

import { cx, styled } from "simplydo/react/styled";
import { List, ListItem } from "simplydo/react/ui/list";
import { Message, MessageHeader } from "simplydo/react/ui/message";

const StyledMessageItem = styled(ListItem)`
  &.is-invalid {
    color: #cc202d;
  }
`;

const PasswordGuidance = ({ password = "" }) => {
  const { t } = useTranslation();
  return (
    <Message>
      <MessageHeader>
        {t("entry.register.passwordGuidance.title")}
      </MessageHeader>
      <List variant="bulleted" compact>
        <StyledMessageItem
          className={cx(
            password.length > 0 && password.length < 8 && "is-invalid",
          )}
        >
          {t("entry.register.passwordGuidance.passwordLimit")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.noRepeat")}
        </StyledMessageItem>
        <StyledMessageItem>
          {t("entry.register.passwordGuidance.manager")}
        </StyledMessageItem>
      </List>
    </Message>
  );
};

export default PasswordGuidance;
